import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { Dispatch } from 'redux'

import { MT4Connector, TradeCommandType } from '@bdswiss/mt4-connector'

import AssetsSelect from '../components/AssetsSelect'
import { RootState, AppMode, TradeMode } from '../types'
import { TradingAction, toggleAssets, selectPosition, setAssetsGroup } from '../actions'
import {
  setTradingSymbol,
  setChartMode,
  setAppMode,
  setTradingSignal,
  clearTradingSignal,
} from '../actions/commonActions'
import { closeTrade } from '../actions/TradeActions'
import { updateFavourites } from '../actions/GraphQLActions'
import { setModal } from '../actions/dialogActions'

const mt4 = MT4Connector.Instance

function mapStateToProps(rootState: RootState) {
  const state = rootState.appState
  const tradeableSignals = Object.values(mt4.tradeableSignals)
    .filter(
      (signal: any) =>
        mt4.assets[signal.symbol]?.['trade'] === TradeMode.enabled ||
        (mt4.assets[signal.symbol]?.['trade'] === TradeMode.onlyBuy && signal.direction === 'UP') ||
        (mt4.assets[signal.symbol]?.['trade'] === TradeMode.onlySell && signal.direction === 'DOWN')
    )
    .reduce(
      (acc, cur) => ({
        ...acc,
        [cur.id]: {
          ...cur,
        },
      }),
      {}
    )
  return {
    appMode: state.appMode,
    opened: state.assetsOpened,
    account: mt4.account,
    accountType:
      rootState.userAccount.viewer.accounts.find(account => account.login == state.activeAccount) // eslint-disable-line eqeqeq
        ?.__typename || '',
    assets: mt4.assets,
    assetGroups: mt4.assetGroups,
    locale: rootState.i18n.locale,
    symbol: state.symbol,
    favourites: rootState.favourites,
    currency: state.currency,
    positions: Array.from(mt4.positions.values()),
    accountLoaded: state.accountLoaded,
    tradeOperationEnabled: rootState.tradingPane.tradeOperationEnabled,
    signals: tradeableSignals,
    telegramSignals: rootState.telegramSignals,
    signal: state.signal,
    dismissedRiscDisclaimer: rootState.appState.dismissedRiscDisclaimer,
    positionsSymbols: [
      ...new Set(Array.from(mt4.positions.values()).map(position => position.symbol)),
    ],
  }
}

function mapDispatchToProps(dispatch: Dispatch<TradingAction>) {
  return {
    onSetTradingSymbol: (symbol: string, tradeType: TradeCommandType) =>
      dispatch(setTradingSymbol(symbol, tradeType)),
    onSetSignal: (signal: any) => dispatch(setTradingSignal(signal)),
    onClearSignal: () => dispatch(clearTradingSignal()),
    onToggleMenu: () => dispatch(toggleAssets()),
    onSetAssetGroup: (group: string) => dispatch(setAssetsGroup(group)),
    onToggleFavourite: (favourites: string[]) => dispatch(updateFavourites(favourites)),
    onCloseTrade: (order: number, uuid?: string) =>
      dispatch(
        setModal(I18n.t(`closingPosition`), I18n.t('closePositionMessage'), closeTrade(order, uuid))
      ),
    onSelectPosition: (order: number, expanded?: boolean) =>
      dispatch(selectPosition(order, expanded)),
    onSetChartMode: () => dispatch(setChartMode('open')),
    onSetAppMode: (mode: AppMode) => dispatch(setAppMode(mode)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetsSelect)
